import React from 'react';
import _ from 'lodash';

import classNames from 'classnames';

import './styles.css';

const Money = ({amount, balance, semibold, className}: any) => {
  const value = !_.isNil(amount) ? parseFloat(amount) : 0.0;
  const absValue = Math.abs(value);

  const derivedClassName = classNames('Money', className, {
    semibold: semibold,
    positive: balance && amount >= 0,
    negative: balance && amount < 0
  });

  return (
    <span className={derivedClassName}>
      {value >= 0 ? `£${absValue.toFixed(2)}` : `-£${absValue.toFixed(2)}`}
    </span>
  );
};

export default Money;
